module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/object/get-own-property-descriptor.js
 ** module id = 739
 ** module chunks = 0
 **/